import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import BuildingSprinklerDashboard from './BuildingSprinklerDashboard';
const queryClient = new QueryClient();
export default function SprinklerSamplingV2({ buildingId }) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(BuildingSprinklerDashboard, { buildingId: buildingId })));
}
